import { BRAND } from 'src/utils/variables';

const defaultStyles = {
  'title-color': 'text-dark-gray',
  'myLocation-icon-color': '',
  'myLocation-button-color': '!text-dark-gray hover:text-dark-gray',
};

const styles: any = {
  DUNLOP: {
    'title-color': 'text-brand-primary',
    'myLocation-icon-color': 'text-brand-primary',
    'myLocation-button-color': 'text-brand-primary',
  },
};

export const getStyling = () => {
  return styles[BRAND] || defaultStyles;
};
